import { useState, useEffect } from 'react';
import { Container } from "reactstrap";
import { CertForm } from "./CertForm";
import { CertTitle } from "./CertTitle";
import { CertConfirm } from './CertConfirm';
import classes from './Certificate.module.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CertCompletion } from './CertCompletion';
import axios from 'axios';



export const Certificate = () => {

    const navigate = useNavigate()
    const [dataOrder, setDataOrder] = useState()
    const [orderStatus, setOrderStatus] = useState()
    const [certToken, setCertToken] = useState()
    const [responseUrl] = useSearchParams();
    const [payStatus, setPayStatus] = useState()
    const resetForm = () => {
        sessionStorage.removeItem("certToken")
        sessionStorage.removeItem("dataOrder")
        setPayStatus(null)
        navigate("/Certificate")
        window.location.reload()
    }

    useEffect(() => {
        setPayStatus(responseUrl.get('paystatus'))
        setCertToken(sessionStorage.getItem("certToken"))
        setDataOrder(JSON.parse(sessionStorage.getItem("dataOrder")))
    }, []
    )
    useEffect(() => {
        if (payStatus == "payed") {
            if (dataOrder == null) {
                navigate("/Certificate")
            }
            else {
                axios.get(`api/certificateorders/completionorder/${dataOrder.orderId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + dataOrder.token,
                        }
                    }).catch((error) => {
                        if (error) {
                            resetForm()
                        }
                    }).then((response) => {
                        setOrderStatus(response)
                    })
                console.log(orderStatus)
            }
        }

    }, [payStatus])

    return (
        window.location.href = 'https://leningradcenter.ru/about-project/certificates'
    )

    return (
        <Container>
            <div className={`${classes.haderCard} mb-3`}>
            </div>
            {payStatus ? <CertCompletion dataOrder={dataOrder} orderStatus={orderStatus} resetForm={resetForm} /> :
                <div>
                    {certToken ? null :
                        <div>
                            <CertTitle />
                            <CertForm setDataOrder={setDataOrder} setCertToken={setCertToken} />
                        </div>
                    }
                    {dataOrder ? <CertConfirm dataOrder={dataOrder} serDataOrder={setDataOrder} /> : null
                    }
                </div>
            }
            <div className="d-flex justify-content-center">
                <div className="logoabr text-center"><img className="img-fluid" src="/Content/img/logoabr.png" /></div>
                <div className={`${classes.cardPay} text-center`}>
                    <ul>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                    </ul>
                </div>
            </div>
        </Container>
    );
}